import React, { useState } from 'react';
import { X } from 'lucide-react';
import './AddWarehouseModal.css';
import axios from 'axios';
import cacheStorage from '../../../utils/cacheStorage';

export default function AddWarehouseModal({ isOpen, onClose, onAddSuccess }) {
  const [formData, setFormData] = useState({
    id: '',
    name: '',
    location: '',
    capacity: '',
    currentStock: '',
    lat: '',
    lng: ''
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  if (!isOpen) return null;

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError(null);

    const payload = {
      name: formData.name,
      address: formData.location,
      location_x: parseFloat(formData.lat) || 0,
      location_y: parseFloat(formData.lng) || 0
    };

    try {
      const token = cacheStorage.getItem('access_token');

      await axios.post('https://smart-cargo-backend-923182991420.us-central1.run.app/api/warehouses', payload, {
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      });

      onAddSuccess(); // trigger refetch or state update in parent
    } catch (err) {
      console.error(err);
      setError(err.message || 'Failed to submit form');
    } finally {
      setLoading(false);
    }
  };


  return (
      <div className="modal-overlay">
        <div className="modal-content">
          <div className="modal-header">
            <h2>Add New Warehouse</h2>
            <button className="modal-close" onClick={onClose}>
              <X size={20} />
            </button>
          </div>

          {error && <div className="modal-error">{error}</div>}

          <form onSubmit={handleSubmit} className="modal-form">
            <div className="form-group">
              <label>Warehouse ID</label>
              <input name="id" value={formData.id} onChange={handleChange} required placeholder="e.g. WH-005" />
            </div>
            <div className="form-group">
              <label>Name</label>
              <input name="name" value={formData.name} onChange={handleChange} required placeholder="e.g. Central Hub" />
            </div>
            <div className="form-group">
              <label>Location</label>
              <input name="location" value={formData.location} onChange={handleChange} required placeholder="e.g. Baku, Azerbaijan" />
            </div>

            <div className="form-row">
              <div className="form-group half">
                <label>Capacity</label>
                <input type="number" name="capacity" value={formData.capacity} onChange={handleChange} required placeholder="0" />
              </div>
              <div className="form-group half">
                <label>Current Stock</label>
                <input type="number" name="currentStock" value={formData.currentStock} onChange={handleChange} required placeholder="0" />
              </div>
            </div>

            <div className="form-row">
              <div className="form-group half">
                <label>Latitude</label>
                <input type="number" step="any" name="lat" value={formData.lat} onChange={handleChange} required placeholder="40.4093" />
              </div>
              <div className="form-group half">
                <label>Longitude</label>
                <input type="number" step="any" name="lng" value={formData.lng} onChange={handleChange} required placeholder="49.8671" />
              </div>
            </div>

            <div className="modal-actions">
              <button type="button" className="btn-cancel" onClick={onClose} disabled={loading}>Cancel</button>
              <button type="submit" className="btn-submit" disabled={loading}>
                {loading ? 'Adding...' : 'Add Warehouse'}
              </button>
            </div>
          </form>
        </div>
      </div>
  );
}